export default __webpack_public_path__ + "static/media/bg-banner-3.6e595883.jpg";